// const UPages = require('../../global/components/check_page');

const component_name = 'slide-form';

(function (component_name) {
    let activeted_item = null;
    let first_item = null;
    let last_item = null;
    let previous_button = null;
    let next_button = null;
    let send_button = null;

    const components = document.getElementsByClassName(component_name);
    if (components.length == 0) return;

    function active_item(item)
    {
        item.classList.add('slide-form__item--active');
        item.classList.remove('slide-form__item--left');
        item.classList.remove('slide-form__item--right');
        activeted_item = item;
    }

    function deactive_item(item)
    {
        item.classList.remove('slide-form__item--active');
    }

    function set_item_to_left(item)
    {
        item.classList.add('slide-form__item--left');
    }

    function set_item_to_right(item)
    {
        item.classList.add('slide-form__item--right');
    }

    function deactive_items(items)
    {
        let side = 'l';
        for (let index = 0; index < items.length; index++) {
            const item = items[index];

            if (activeted_item === item)
            {
                side = 'r'
                continue;
            }

            deactive_item(item);

            if (side == 'l')
            {
                set_item_to_left(item)
            }
            else if (side == 'r')
            {
                set_item_to_right(item)
            }
        }
    }

    function getItems(items)
    {
        const last_index = items.length - 1;
        first_item = items[0];
        last_item = items[last_index];

        active_item(first_item);
        deactive_items(items);
    }

    function active_control(control)
    {
        control.classList.remove('slide-form__control--hidden');
    }

    function deactive_control(control)
    {
        control.classList.add('slide-form__control--hidden');
    }

    function manager_controls()
    {
        active_control(previous_button);
        active_control(next_button);
        deactive_control(send_button);

        if (first_item === last_item)
        {
            active_control(send_button);
            deactive_control(previous_button);
            deactive_control(next_button);
            return;
        }

        if (first_item === activeted_item)
        {
            deactive_control(previous_button);
        }

        if (last_item === activeted_item)
        {
            active_control(send_button);
            deactive_control(next_button);
        }
    }

    function getButtons(component, items)
    {
        previous_button = component.querySelector('[slide-form-control="previous"]');
        next_button = component.querySelector('[slide-form-control="next"]');
        send_button = component.querySelector('[slide-form-control="send"]');
        const toTop = component.querySelector(previous_button.dataset.click);

        previous_button.addEventListener('click', e => {
            e.preventDefault();

            if (toTop) toTop.click();

            if (activeted_item.previousElementSibling === null) return;
            activeted_item = activeted_item.previousElementSibling;
            active_item(activeted_item);
            deactive_items(items);

            manager_controls();
        });

        next_button.addEventListener('click', e => {
            e.preventDefault();

            if (toTop) toTop.click();

            if (activeted_item.nextElementSibling === null) return;
            activeted_item = activeted_item.nextElementSibling;
            active_item(activeted_item);
            deactive_items(items);

            manager_controls();
        });


        manager_controls();
    }

    for (let index = 0; index < components.length; index++) {
        const component = components[index];
        const items = component.querySelectorAll('.slide-form__items li');
        if (items.length == 0) return;
        getItems(items);
        getButtons(component, items);
    }

})(component_name);